// extracted by mini-css-extract-plugin
export var infoItem = "_u8-2";
export var title = "_u8-0";
export var value = "_u8-1";